import { getConfig } from './config';

function getHeaders(token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = token;
  return headers;
}

function apiUrl(path) {
  return `${getConfig().apiEndpoint}${path}`;
}

// Public endpoints
export async function getPlants(params = {}) {
  const query = new URLSearchParams(params).toString();
  const resp = await fetch(apiUrl(`/api/plants${query ? '?' + query : ''}`));
  return resp.json();
}

export async function getPlant(id) {
  const resp = await fetch(apiUrl(`/api/plants/${id}`));
  return resp.json();
}

export async function getPhotos(plantId, params = {}) {
  const query = new URLSearchParams(params).toString();
  const resp = await fetch(apiUrl(`/api/photos/${plantId}${query ? '?' + query : ''}`));
  return resp.json();
}

export async function getCategories() {
  const resp = await fetch(apiUrl('/api/categories'));
  return resp.json();
}

// Authenticated endpoints
export async function createPlant(data, token) {
  const resp = await fetch(apiUrl('/api/plants'), {
    method: 'POST', headers: getHeaders(token), body: JSON.stringify(data),
  });
  return resp.json();
}

export async function updatePlant(id, data, token) {
  const resp = await fetch(apiUrl(`/api/plants/${id}`), {
    method: 'PUT', headers: getHeaders(token), body: JSON.stringify(data),
  });
  return resp.json();
}

export async function deletePlant(id, token) {
  const resp = await fetch(apiUrl(`/api/plants/${id}`), {
    method: 'DELETE', headers: getHeaders(token),
  });
  return resp.json();
}

export async function getUploadUrl(data, token) {
  const resp = await fetch(apiUrl('/api/photos/upload-url'), {
    method: 'POST', headers: getHeaders(token), body: JSON.stringify(data),
  });
  return resp.json();
}

export async function bulkImport(csvData, token) {
  const resp = await fetch(apiUrl('/api/plants/bulk-import'), {
    method: 'POST', headers: getHeaders(token), body: JSON.stringify({ csvData }),
  });
  return resp.json();
}

export async function getDashboardStats(token) {
  const resp = await fetch(apiUrl('/api/dashboard/stats'), {
    headers: getHeaders(token),
  });
  return resp.json();
}

// Gallery endpoints (general garden photos, not tied to a specific plant)
export async function getGalleryUploadUrl(data, token) {
  const resp = await fetch(apiUrl('/api/gallery/upload-url'), {
    method: 'POST', headers: getHeaders(token), body: JSON.stringify(data),
  });
  return resp.json();
}

export async function getGalleryPhotos(category) {
  const resp = await fetch(apiUrl(`/api/gallery/${category}`));
  return resp.json();
}

export async function deleteGalleryPhoto(category, uploadDate, token) {
  const resp = await fetch(apiUrl(`/api/gallery/${category}?uploadDate=${encodeURIComponent(uploadDate)}`), {
    method: 'DELETE', headers: getHeaders(token),
  });
  return resp.json();
}
